import React from 'react'
import SectionItem from '../../../Layout/SectionItem/SectionItem'
import './Answer.scss'
import { LuxIcon } from '@lux/wardrobe-lib'
import { InputTextarea } from 'primereact/inputtextarea'
import { useIntl } from 'react-intl'
import { Answer as IAnswer } from '@/app/models/new-activity-creation-state'

const Answer = (props) => {
    const componentClass = 'smart-new-activity-action-answer'
    const { answerList, updateAnswerList, onUpdateAnswer, onRemoveAnswer, disabled } = props
    const intl = useIntl()

    const addNewAnswer = () => {
        onUpdateAnswer(answerList.length, '')
    }
    const updateAnswer = (index: number, value: string) => {
        onUpdateAnswer(index, value)
    }
    const onPencil = (index: number, answer: IAnswer) => {
        updateAnswerList(index, answer.value, false)
    }
    const onSend = (index: number, answer: IAnswer) => {
        onUpdateAnswer(index, answer.value, true)
    }
    const onRemove = (index: number) => {
        onRemoveAnswer(index)
    }

    return (
        <SectionItem>
            <div className={componentClass}>
                {answerList.map((answer, index) => (
                    <div className={`${componentClass}__text`} key={index}>
                        <InputTextarea
                            placeholder={intl.formatMessage({
                                id: 'modals.new.activity.section.action.question.add.answer.new',
                                defaultMessage: 'Type here...',
                            })}
                            autoResize
                            rows={1}
                            value={answer.value}
                            onChange={(e) => updateAnswer(index, e.target.value)}
                            disabled={answer.disabled || disabled}
                        />
                        <div className={`${componentClass}__cta-container`}>
                            {answer.disabled && !disabled && (
                                <LuxIcon
                                    icon="pencil"
                                    onClick={onPencil.bind(null, index, answer)}
                                />
                            )}
                            {!answer.disabled && disabled && (
                                <LuxIcon icon="send" onClick={onSend.bind(null, index, answer)} />
                            )}
                            <LuxIcon icon="trash" onClick={onRemove.bind(null, index)} />
                        </div>
                    </div>
                ))}
                {!disabled && (
                    <div className={`${componentClass} link`} onClick={addNewAnswer}>
                        {intl.formatMessage({
                            id: 'modals.new.activity.section.action.question.add.answer',
                            defaultMessage: 'Add answer',
                        })}
                    </div>
                )}
            </div>
        </SectionItem>
    )
}

export default Answer
